import React from 'react';

export default function Brand() {
	return (
		<div className="brand">
			<span>weatherweb.</span>
		</div>
	);
}